import React, { useCallback, useEffect, useState } from 'react';
import { trackEvent } from '../firebaseAnalytics';

const WAITLIST_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwGVL1MFFmAIU9p1RFFvH_SaP1OWjnZ3uzczKJurzdSB9523N4N67H4vPPM8X6Z7OWt/exec';

function isValidEmail(v){
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

export default function WaitlistModal(){
  const [status, setStatus] = useState({ message: '', type: '' });

  const closeModal = useCallback(()=>{
    const modal = document.getElementById('waitlistModal');
    if(modal){
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
    }
  }, []);

  const openHandler = useCallback((e, source = 'unknown')=>{
    e && e.preventDefault && e.preventDefault();
    const modal = document.getElementById('waitlistModal');
    if(!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden','false');
    trackEvent('waitlist_open', {
      source,
    });
    // intentionally do NOT focus the email input on open to respect user's request
  }, []);

  useEffect(()=>{
    const modal = document.getElementById('waitlistModal');
    const openerSelector = '#openWaitlist, #openWaitlist2, #openWaitlist3, [data-waitlist-open]';
    const delegatedOpenHandler = (e)=>{
      const opener = e.target instanceof Element ? e.target.closest(openerSelector) : null;
      if(!opener) return;
      openHandler(e, opener.id || opener.getAttribute('data-waitlist-open') || 'unknown');
    };

    document.addEventListener('click', delegatedOpenHandler);

    const modalClickHandler = (e)=>{ if(e.target===modal) closeModal(); };
    const keyHandler = (e)=>{ if(e.key==='Escape') closeModal(); };
    modal && modal.addEventListener('click', modalClickHandler);
    document.addEventListener('keydown', keyHandler);

    return ()=>{
      document.removeEventListener('click', delegatedOpenHandler);
      modal && modal.removeEventListener('click', modalClickHandler);
      document.removeEventListener('keydown', keyHandler);
    };
  }, [closeModal, openHandler]);

  async function handleSubmit(e){
    e.preventDefault();
    const emailEl = document.getElementById('wlEmail');
    const value = emailEl ? emailEl.value.trim() : '';

    if(!isValidEmail(value)){
      setStatus({ message: 'Please enter a valid email.', type: 'err' });
      emailEl && emailEl.focus();
      return;
    }

    setStatus({ message: 'Submitting...', type: 'info' });

    try {
      if(WAITLIST_ENDPOINT){
        const fd = new FormData();
        fd.append('email', value);

        await fetch(WAITLIST_ENDPOINT, {
          method: 'POST',
          body: fd,
          mode: 'no-cors',
          cache: 'no-store',
          redirect: 'follow'
        });

        trackEvent('waitlist_submit', {
          source: 'waitlist_modal',
        });
        setStatus({ message: 'Thanks! You’re on the waitlist.', type: 'ok' });
        setTimeout(()=>{
          closeModal();
          setStatus({ message: '', type: '' });
          if(emailEl) emailEl.value = '';
        }, 900);
        return;
      }
    } catch(err){
      console.warn('Waitlist submit failed:', err);
      setStatus({ message: 'Hmm, something went wrong. Please try again.', type: 'err' });
      return;
    }

    const subject = encodeURIComponent('Waitlist signup');
    const body = encodeURIComponent(`Email: ${value}\nSource: promptera.com coming soon`);
    window.location.href = `mailto:info@promptera.io?subject=${subject}&body=${body}`;
    setStatus({ message: 'Thanks! Your email app should open to confirm.', type: 'ok' });
    setTimeout(()=>{
      closeModal();
      setStatus({ message: '', type: '' });
      if(emailEl) emailEl.value = '';
    }, 600);
  }

  return (
    <div id="waitlistModal" className="modal" aria-hidden="true" role="dialog" aria-labelledby="wlTitle">
      <div className="modal-card glass card">
        <div className="shine" />
        
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',marginBottom:12}}>
            <h1 className="wlTitle">Get Early Access</h1>
            <h2 id="wlTitle" style={{margin:'-18px 0 0', color:'rgba(184, 199, 217, 0.5)', fontWeight: '500'}}>Reserve your spot instantly</h2>
        </div>
        <form style={{padding:'12px 0'}} onSubmit={handleSubmit}>
          <label htmlFor="wlEmail" className="sr">Email</label>
          <input id="wlEmail" type="email" className="input" placeholder="Email" required />
          {status.message && (
            <p className={`msg ${status.type}`} style={{marginTop: 8, textAlign: 'center', minHeight: 24}}>{status.message}</p>
          )}
          <div style={{height:12}} />

          <div className="wl-footer-row" style={{display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column', gap:15}}>
            <button className="btn btn-primary" type="submit" style={{padding: '12px 32px',borderRadius: '18px', justifyContent: 'center', boxShadow: '0 12px 30px rgba(3,8,18,0.55)'}}>Join Waitlist</button>
          </div>
        </form>
      </div>
    </div>
  );
}
